webpackJsonp([15],{

/***/ 99:
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;/*
	* 注册handlebar全局helpers
	*
	* */
	!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
	    var Handlebars = __webpack_require__(14);
	    var compareHelpers = {
	
	        /**
	         * Or
	         * Conditionally render a block if one of the values is truthy.
	         */
	        or: function (a, b, options) {
	            if (a || b) {
	                return options.fn(this);
	            } else {
	                return options.inverse(this);
	            }
	        },
	
	        // 获取数组第一个元素
	        getFirstElement: function(arr, orgId) {
	            if (typeof arr === 'object') {
	                return location.protocol + '//'+ location.host +'/@context.name@/s?func=lp:getImg&img_id='+ arr[0] +'&org_id=' + orgId;
	            } else {
	                return arr;
	            }
	        },
	        // 判断数组是否为空
	        isArrayNotNull: function(a, options) {
	            if (typeof a === 'object' && a.length !== 0) {
	                return options.fn(this);
	            } else {
	                return options.inverse(this);
	            }
	        }
	    };
	
	    // register helpers
	    for (var helper in compareHelpers) {
	        if (compareHelpers.hasOwnProperty(helper)) {
	            Handlebars.registerHelper(helper, compareHelpers[helper]);
	        }
	    }
	
	    return Handlebars;
	}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ },

/***/ 155:
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;;!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
	        var $ = __webpack_require__(1);
	        var Cookie = __webpack_require__(32);
	        var cookieNames = {
	            face: 'face'                 // 风格
	        }
	        var cookieOptions = {expires : 30, path : '/'};
	        var customRadioCheckbox = function($wrap) {
	            $wrap.customRadioCheckbox();
	        };
	
	        var blurBgImg = function() {
	            /* globals SYS_CONST, CUSTOME_DATA, DATA */
	            window.SYS_CONST = window.SYS_CONST || {};
	            window.CUSTOME_DATA = window.CUSTOME_DATA || {};
	            var indexData = CUSTOME_DATA.indexPageData2 || {};
	            var isCustomizeBg = false;
	            var imgUrlPrefix = '';
	            var faceSetting = SYS_CONST.faceSetting;
	
	            // 未定制情况下indexData为空，根据该条件做区分
	            if (!$.isEmptyObject(indexData)) {
	                var realResource = indexData.real_resource || {};
	                window.DATA = $.extend(true, {}, realResource, {orgId: indexData.org ? indexData.org : ''});
	                DATA.facade_custom = DATA.facade_custom || {};
	                var copyrightText = DATA.facade_custom.copyright_text;
	                if (copyrightText) {
	                    DATA.facade_custom.copyright_text = copyrightText.replace(/&/g, '&amp;').replace(/>/g, '&gt;')
	                            .replace(/</g, '&lt;').replace(/"/g, '&quot;').replace(/'/g, '&#39;').replace('&amp;copy;', '&copy;');
	                }
	                // 定制背景
	                isCustomizeBg = DATA.facade_custom.background && DATA.facade_custom.background.length !== 0;
	
	                imgUrlPrefix = location.protocol + '//'+ location.host +'/@context.name@/s?func=lp:getImg&org_id=' + DATA.orgId + '&img_id=';
	                // 通过构造样式文件来实现样式定制
	                _makeCustomizeStyle(DATA, isCustomizeBg, imgUrlPrefix);
	                // 设置浏览器tab的title以及icon
	                _setTabTitleFavor(DATA, imgUrlPrefix);
	            }
	
	            function _makeCustomizeStyle(data, isCustomizeBg, imgUrlPrefix) {
	                var styleStr = '';
	
	                styleStr += _makeStyleBlockStr('label.slogan', {
	                    'color': data.facade_custom.slogan_color,
	                    'font-size': data.facade_custom.slogan_fontsize ? data.facade_custom.slogan_fontsize + 'px' : ''
	                });
	                styleStr += _makeStyleBlockStr('div.main-bottom', {
	                    'background-color': data.facade_custom.background_color
	                });
	                if (isCustomizeBg) {
	                    styleStr += _makeStyleBlockStr('div.main-bottom', {
	                        'background-image': 'url(' + imgUrlPrefix + data.facade_custom.background[0] + ')',
	                        'filter': 'progid:DXImageTransform.Microsoft.AlphaImageLoader(src="'+ imgUrlPrefix + data.facade_custom.background[0] + '", sizingMethod="scale")'
	                    });
	                }
	                styleStr += _makeStyleBlockStr('button.u-btn', {
	                    'background-color': data.facade_custom.submit_button_color,
	                    'color': data.facade_custom.submit_button_font_color
	                });
	
	                $('#dHead').append($('<style type="text/css">' + styleStr + '</style>'));
	            }
	
	            function _makeStyleBlockStr(selector, items) {
	                var result = '';
	                if ($.isEmptyObject(items)) {
	                    return result;
	                }
	
	                result += selector + '{';
	                $.each(items, function(key, value) {
	                    if (value) {
	                        result += key + ':' + value + ';';
	                    }
	                });
	                result += '}';
	
	                return result;
	            }
	
	            function _setTabTitleFavor(data, imgUrlPrefix) {
	                if (data.facade_custom.favor_title) {
	                    document.title = data.facade_custom.favor_title;
	                }
	                if (data.facade_custom.favor && data.facade_custom.favor.length !== 0) {
	                    var favorUrl = imgUrlPrefix + data.facade_custom.favor[0] + '&hash=' + Math.random();
	                    var link = document.createElement('link');
	                    link.type = 'image/x-icon';
	                    link.rel = 'shortcut icon';
	                    link.href = favorUrl;
	                    document.getElementsByTagName('head')[0].appendChild(link);
	                }
	            }
	            Cookie.set(cookieNames.face, faceSetting || 'XT5', cookieOptions);
	
	            if (!isCustomizeBg) {
	                var num = Math.round(Math.random() * 3);
	                $('.main-bottom').addClass('main-bottom-' + num);
	                $('.main-middle').addClass('main-middle-' + num);
	            }
	            if (!(/MSIE (6|7)/i).test(navigator.userAgent)) {
	                setTimeout(function() {
	                    $('.aside-blur').blurjs({
	                        source: '.main-bottom',  //模糊背景的selector
	                        radius: 5,               //模糊半径
	                        cacheExpired: 30 * 1000,
	                        cache: false
	                    });
	                }, 500);
	
	            }
	        };
	
	        /**
	         * 毛玻璃图片
	         * 参考：https://github.com/jakiestfu/Blur.js
	         *
	         * 在原仓库的基础上，将核心的计算过程移到独立脚本，由WebWorker 运行，避免UI 线程被阻塞
	         * */
	        $.fn.blurjs = function (options) {
	            options.cacheExpired = options.cacheExpired || Number.MAX_VALUE;
	            var curMS = (new Date()).getTime();
	            var canvas = document.createElement('canvas');
	            var isCached = false;
	            var selector = ($(this).selector).replace(/[^a-zA-Z0-9]/g, '');
	
	            // 为了保证需求和性能，毛玻璃图片只在同时支持canvas 和WebWorker 的浏览器生效
	            if (!canvas.getContext || !('Worker' in window)) {
	                return;
	            }
	            options = $.extend({
	                source: 'body',
	                radius: 5,
	                overlay: '',
	                offset: {
	                    x: 0,
	                    y: 0
	                },
	                optClass: '',
	                cache: false,
	                cacheKeyPrefix: 'blurjs-',
	                draggable: false,
	                debug: false
	            }, options);
	
	            function stackBlurCanvasRGB(a, b, c, d, f, g) {
	                var dfd = $.Deferred();
	                var worker = __webpack_require__(486)();
	
	                if (isNaN(g) || g < 1) return;
	                g |= 0;
	                var h = a.getContext('2d');
	                var j;
	                try {
	                    try {
	                        j = h.getImageData(b, c, d, f)
	                    } catch (e) {
	                        try {
	                            // eslint-disable-next-line no-undef
	                            netscape.security.PrivilegeManager.enablePrivilege('UniversalBrowserRead');
	                            j = h.getImageData(b, c, d, f)
	                        } catch (e) {
	                            alert('Cannot access local image');
	                            throw new Error('unable to access local image data: ' + e);
	                        }
	                    }
	                } catch (e) {
	                    alert('Cannot access image');
	                    throw new Error('unable to access image data: ' + e);
	                }
	
	                worker.onmessage = function(e) {
	                    var data = e.data;
	
	                    if (data.type === 'afterCal') {
	                        h.putImageData(data.j, b, c);
	                        return dfd.resolve();
	                    }
	                };
	
	                worker.postMessage({
	                    type: 'cal',
	                    d: d,
	                    j: j,
	                    g: g,
	                    f: f
	                });
	
	                return dfd.promise();
	            }
	
	            return this.each(function () {
	                var $glue = $(this);
	                var $source = $(options.source);
	                var formattedSource = ($source.css('backgroundImage')).replace(/"/g, '').replace(/url\(|\)$/ig, '');
	                var ctx = canvas.getContext('2d');
	                var tempImg = new Image();
	                var cachedDate;
	                tempImg.onload = function () {
	                    function afterDone(blurredData) {
	                        var attachment = $source.css('backgroundAttachment');
	                        var position = (attachment === 'fixed') ? '' : '-' + (($glue.offset().left) - ($source.offset().left) - (options.offset.x)) + 'px -' + (($glue.offset().top) - ($source.offset().top) - (options.offset.y)) + 'px';
	                        $glue.css({
	                            'background-image': 'url("' + blurredData + '")',
	                            'background-repeat': $source.css('backgroundRepeat'),
	                            'background-position': position,
	                            'background-attachment': attachment
	                        });
	                        if (options.optClass !== false) {
	                            $glue.addClass(options.optClass);
	                        }
	                        if (options.draggable) {
	                            $glue.css({
	                                'background-attachment': 'fixed',
	                                'background-position': '0 0'
	                            });
	                            $glue.draggable();
	                        }
	                    }
	                    if (!isCached) {
	                        canvas.style.display = 'none';
	                        canvas.width = tempImg.width;
	                        canvas.height = tempImg.height;
	                        ctx.drawImage(tempImg, 0, 0);
	                        stackBlurCanvasRGB(canvas, 0, 0, canvas.width, canvas.height, options.radius).then(function() {
	                            if (options.overlay) {
	                                ctx.beginPath();
	                                ctx.rect(0, 0, tempImg.width, tempImg.width);
	                                ctx.fillStyle = options.overlay;
	                                ctx.fill();
	                            }
	                            var blurredData = canvas.toDataURL();
	                            if (options.cache) {
	                                try {
	                                    if (options.debug) {
	                                        console.log('Cache Set');
	                                    }
	                                    localStorage.setItem(options.cacheKeyPrefix + selector + '-' + formattedSource + '-data-image', blurredData);
	                                    cachedDate = localStorage.setItem(options.cacheKeyPrefix + selector + '-' + formattedSource + '-data-image-cacheAt', curMS);
	                                } catch (e) {
	                                    console.log(e);
	                                }
	                            }
	                            afterDone(blurredData);
	                        });
	                    } else {
	                        afterDone(tempImg.src);
	                    }
	                };
	                Storage.prototype.cacheChecksum = function (opts) {
	                    var newData = '';
	                    for (var key in opts) {
	                        var obj = opts[key];
	                        if (obj.toString() === '[object Object]') {
	                            newData += ((obj.x).toString() + (obj.y).toString() + ',').replace(/[^a-zA-Z0-9]/g, '');
	                        } else {
	                            newData += (obj + ',').replace(/[^a-zA-Z0-9]/g, '');
	                        }
	                    }
	                    var originalData = this.getItem(options.cacheKeyPrefix + selector + '-' + formattedSource + '-options-cache');
	                    if (originalData !== newData) {
	                        this.removeItem(options.cacheKeyPrefix + selector + '-' + formattedSource + '-options-cache');
	                        this.setItem(options.cacheKeyPrefix + selector + '-' + formattedSource + '-options-cache', newData);
	                        if (options.debug) {
	                            console.log('Settings Changed, Cache Emptied');
	                        }
	                    }
	                };
	                var cachedData = null;
	                if (options.cache) {
	                    localStorage.cacheChecksum(options);
	                    cachedDate = localStorage.getItem(options.cacheKeyPrefix + selector + '-' + formattedSource + '-data-image-cacheAt');
	                    var internalDate = parseInt(curMS) - parseInt(cachedDate);
	                    if (internalDate > 0 && internalDate < options.cacheExpired) {
	                        cachedData = localStorage.getItem(options.cacheKeyPrefix + selector + '-' + formattedSource + '-data-image');
	                    }
	                }
	                if (cachedData != null) {
	                    if (options.debug) {
	                        console.log('Cache Used');
	                    }
	                    isCached = true;
	                    tempImg.src = (cachedData);
	                } else {
	                    if (options.debug) {
	                        console.log('Source Used');
	                    }
	                    tempImg.src = formattedSource;
	                }
	            });
	        };
	
	        /*!
	         * jQuery Custom Radio Checkbox Plugin
	         * Copyright (c) 2012-2014 Denis Ciccale (@tdecs)
	         * Released under MIT license (https://raw.github.com/dciccale/Custom-radio-checkbox/master/LICENSE.txt)
	         */
	        $.fn.customRadioCheckbox = function (/*options*/) {
	            // don't act on absent elements, can't chain anyway
	            if (!this[0]) {
	                return;
	            }
	
	            // checked suffix
	            var checkedSuffix = '-checked';
	
	            // css class used to hide inputs
	            var hiddenInputClass = 'rc-hidden';
	
	            var disabledClass ='rc-disabled';
	
	            // function to force the input change when clicking
	            // on a fake input that is not wrapped by a label tag
	            var forceChange = function () {
	                var $this = $(this);
	                // only trigger if the input is not inside a label
	                if (!$this.closest('label')[0]) {
	                    $this.prev().trigger('change.crc', [true]);
	                }
	            };
	
	            // function that inserts the fake input
	            var insertFakeInput = function (inputs) {
	                var type = inputs.type;
	                var l = inputs.length;
	                var isDisable;
	                var fakeInputElem, input;
	
	                while (l--) {
	                    // current input
	                    input = inputs[l];
	                    isDisable = $(input).prop('disabled');
	
	                    // fake input
	                    fakeInputElem = $('<i>')
	                            .addClass(type + (input.checked ? ' ' + type + checkedSuffix : ''));
	
	                    fakeInputElem.bind('click.crc', forceChange);
	                    isDisable && fakeInputElem.addClass(disabledClass);
	
	                    // insert the fake input after the input
	                    input.parentNode.insertBefore(fakeInputElem[0], input.nextSibling);
	                }
	            };
	
	            return this.each(function () {
	
	                var $context = $(this);
	
	                // find & hide radios
	                var rds = $context.find('input[type=radio]:not(.' + hiddenInputClass + ')')
	                        .addClass(hiddenInputClass);
	
	                // find & hide checkboxes
	                var chs = $context.find('input[type=checkbox]:not(.' + hiddenInputClass + ')')
	                        .addClass(hiddenInputClass);
	
	                // storage for each radio group to optimize next lookup
	                var rdsCache = {};
	
	                // total radios
	                var rdsLength = rds.length;
	                var rd;
	
	                // only apply if there are radios
	                if (rds.length) {
	                    rds.type = 'radio';
	
	                    // insert each fake radio
	                    insertFakeInput(rds);
	
	                    // initialize rdsCache for prechecked inputs
	                    while (rdsLength--) {
	                        rd = rds[rdsLength];
	                        if (rd.checked) {
	                            (rdsCache[rd.name] = {}).checked = $(rd.nextSibling);
	                        }
	                    }
	
	                    // bind radio change event
	                    rds.bind('change.crc', function (e, force) {
	                        if ($(this).prop('disabled')) {
	                            return false;
	                        }
	                        // uncheck previous and remove checked class
	                        if (!force || !this.checked) {
	
	                            // filter by name and remove class from the last radio checked
	                            // save this collection in cache obj for faster use
	                            if (!rdsCache[this.name]) {
	                                rdsCache[this.name] = {};
	                            }
	
	                            // uncheck last checked from this group
	                            if (rdsCache[this.name].checked) {
	                                rdsCache[this.name].checked.removeClass(rds.type + checkedSuffix);
	                            }
	
	                            // add checked class to this input and save it as checked for this group
	                            rdsCache[this.name].checked = $(this.nextSibling).addClass(rds.type + checkedSuffix);
	                        }
	
	                        // if force set to true and is not already checked, check the input
	                        if (force && !this.checked) {
	                            this.checked = true;
	                        }
	                    });
	                }
	
	                // only apply if there are checkboxes
	                if (chs.length) {
	                    chs.type = 'checkbox';
	
	                    // insert each fake checkbox
	                    insertFakeInput(chs);
	
	                    // bind checkbox change event
	                    chs.bind('change.crc', function (e, force) {
	                        if ($(this).prop('disabled')) {
	                            return false;
	                        }
	                        // force change state
	                        if (force) {
	                            this.checked = !this.checked;
	                        }
	
	                        // toggle checked class
	                        $(this.nextSibling).toggleClass(chs.type + checkedSuffix);
	                    });
	                }
	            });
	        };
	
	        return {
	            customRadioCheckbox: customRadioCheckbox,
	            blurBgImg: blurBgImg
	        };
	    }.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ },

/***/ 156:
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;/**
	 * 关于webmail 登录设备（信任设备）的逻辑备注：
	 * 1. 考虑到信任设备信息的存储安全性以及浏览器在存储方面的限制，
	 *    后端（loginSuccessTransit.tag）会将存到cookies 中的信息移入localStorage，
	 *    如果浏览器不支持localStorage，则会清空之前的token 信息
	 * 2. 后端在登录流程的信任设备逻辑大致如下：
	 *     1）若系统不支持登录设备记录，则不会生成或更新设备信息；
	 *     2）若系统支持登录设备记录，但webmail 提交的数据中既没有accessToken 也没有deviceInfo，则不会生成或更新设备信息；
	 * 3. 针对上面的描述，webmail 对登录设备信息做如下处理：
	 *     1）若系统不支持登录设备记录，则不需要收集token、deviceInfo，因为没必要，而localStorage 或cookies 中如果有信息也是过时的
	 *     2）若系统支持登录设备记录，且浏览器不支持localStorage，则会尝试收集cookies 中的token 字段信息用作登录设备之用，不会用作信任设备
	 *     3）若系统支持登录设备记录，且浏览器支持localStorage，考虑到用户数据兼容性，旧版的webmail 会将token 写入到cookies
	 *        需要尝试从localStorage、cookies中读取token 信息。无论有没有找到token 信息，都需要生成deviceInfo 让后端生成设备信息
	 * */
	
	/* eslint-disable camelcase */
	
	;!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
	        var $ = __webpack_require__(1);
	        var Detector = __webpack_require__(40);
	        var jsSHA = __webpack_require__(457);
	        var Cookie = __webpack_require__(32);
	
	        /**
	         * 测试是否支持localStorage
	         * */
	        var supportLocalStorage = (function() {
	            var test = 'cm.ls.test';
	            try {
	                localStorage.setItem(test, test);
	                localStorage.removeItem(test);
	                return true;
	            } catch (e) {
	                return false;
	            }
	        }());
	
	        var token_cookie_prefix = {
	            token: 'Coremail.token.',
	            secret: 'Coremail.secret.',
	            nonce: 'Coremail.nonce.'
	        };
	
	        /**
	         * 从cookie 中收集token、secret、nonce
	         *
	         * @return {object} 信任设备需要的登录凭证
	         * */
	        function collectAuthMapFromCookies(uid) {
	            var cookiePrefix = token_cookie_prefix;
	            function removeCookieColon(value) {
	                if (typeof value !== 'string' || !value.length) return value;
	                if (value[0] === '"' && value[value.length - 1] === '"') {
	                    value = value.slice(1, -1);
	                }
	                return value;
	            }
	
	            var _token, _secret, _nonce;
	
	            _token = Cookie.get(cookiePrefix.token + encodeURI(uid));
	
	            if (!_token) return null;
	
	            _token = removeCookieColon(_token);
	
	            // 若浏览器不支持localStorage，考虑到信任设备信息的安全性，不需要获取secret、nonce，只做登录设备之用
	            if (!supportLocalStorage) {
	                Cookie.remove(cookiePrefix.secret + encodeURI(uid), {path : '/'});
	                Cookie.remove(cookiePrefix.nonce + encodeURI(uid), {path : '/'});
	                _secret = false;
	                _nonce = false;
	            } else {
	                _secret = removeCookieColon(Cookie.get(cookiePrefix.secret + encodeURI(uid)) || '');
	                _nonce = removeCookieColon(Cookie.get(cookiePrefix.nonce + encodeURI(uid)) || '');
	            }
	
	            return {
	                token: _token,
	                secret: _secret,
	                nonce: _nonce
	            }
	        }
	
	        /**
	         * 从LocalStorage 中收集token、secret、nonce
	         *
	         * @return {object} 信任设备需要的登录凭证
	         * */
	        function collectAuthMapFromLocalStorage(uid, timeStamp) {
	            var _token, _secret, _nonce, _expires;
	
	            var lsKey = 'Coremail.auth.' + uid;
	
	            // 不支持localStorage
	            if (!supportLocalStorage) return null;
	
	            var authValue = localStorage.getItem(lsKey);
	
	            // localStorage 中没有值
	            if (authValue == null) return null;
	
	            authValue = $.parseJSON(authValue);
	
	            _token = authValue['token'];
	            _secret = authValue['secret'];
	            _nonce = authValue['nonce'];
	            _expires = Math.ceil(authValue['expires'] / 1000);
	
	            // 检查token 的有效时长
	            if (!isNaN(_expires) && timeStamp && _expires < timeStamp) {
	                localStorage.removeItem(lsKey);
	                return null;
	            }
	
	            return {
	                token: _token,
	                secret: _secret,
	                nonce: _nonce
	            }
	        }
	
	        /**
	         * 收集信任设备凭证的入口
	         *
	         * 新的实现已将数据保存在localStorage 中，为了让存在cookies 上用户的旧数据顺利过渡，会保留从cookies 中搜集数据的逻辑
	         * 服务器会在成功登录后，将cookies 中的数据清空，并移至到localStorage 中。
	         *
	         * 对于不支持localStorage 的登录设备，服务器会向cookies 写入token，但没有secret 等信息。
	         * */
	        function collectAuthMap(uid) {
	
	            var _timestamp = Math.ceil((new Date()).getTime() / 1000);
	            var _token, _secret, _nonce, _signature, _hashObj;
	
	            var authMap = collectAuthMapFromLocalStorage(uid, _timestamp) || collectAuthMapFromCookies(uid);
	            if (authMap == null) return null;
	
	            _token = authMap.token;
	            _secret = authMap.secret;
	            _nonce = authMap.nonce;
	
	            if (_token && _secret && _nonce) {
	                // 签名的计算查看user:login 接口文档
	                _hashObj = new jsSHA('SHA-1', 'TEXT', {numRounds: 1});      // eslint-disable-line new-cap
	                _hashObj.update('accessToken=' + encodeURIComponent(_token)
	                                + '&nonce=' + encodeURIComponent(_nonce)
	                                + '&timestamp=' + encodeURIComponent(_timestamp)
	                                + '&secret=' + encodeURIComponent(_secret));
	                _signature = _hashObj.getHash('B64');
	            } else {
	                _signature = false;
	            }
	
	            return {
	                token: _token,
	                secret: _secret,
	                nonce: _nonce,
	                signature: _signature,
	                timestamp: _timestamp
	            }
	        }
	
	        // 格式化登录token 凭据，并设置到对应的表单元素中
	        function formatLoginToken(uid) {
	            if (!uid) return null;
	
	            var authMap = collectAuthMap(uid);
	
	            if (authMap == null || !authMap.token) return null;
	            return authMap;
	        }
	
	        // 收集当前登录设备信息
	        function collectDeviceInfo() {
	            var device = Detector.device;
	            var os = Detector.os;
	            var browser = Detector.browser;
	            var unknownInfo = 'na';
	
	            var friendlyName;
	            var model = '';
	
	            // webmail 的设备名称使用浏览器 + 版本号
	            if (browser.name === unknownInfo) {
	                friendlyName = unknownInfo;
	            } else {
	                friendlyName = browser.name;
	                if (browser.version !== '-1') {
	                    friendlyName += (' ' + browser.version);
	                }
	            }
	
	            // 如果webmail 设备名被检测为pc，则替换为系统名
	            if (device.name === unknownInfo || device.name === 'pc') {
	                model = os.name;
	            } else {
	                model = device.name;
	            }
	
	            var deviceInfo = {
	                uuid: 'webmail_' + model,
	                imie: 'webmail_' + model,
	                friendlyName: friendlyName,
	                model: model,
	                os: os.name,
	                osLanguage: navigator.language,
	                deviceType: 'Webmail'
	            };
	            return deviceInfo;
	        }
	
	        // 格式化登录设备信息，并设置到对应表单元素中
	        function formatLoginDeviceInfo() {
	            return collectDeviceInfo();
	        }
	
	        return {
	            supportLocalStorage: supportLocalStorage,
	            formatLoginToken: formatLoginToken,
	            formatLoginDeviceInfo: formatLoginDeviceInfo
	        }
	    }.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ },

/***/ 157:
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;/*
	 * Copyright (c) 2016 Mailtech.cn, Ltd. All Rights Reserved.
	 */
	
	/* global WsStore */
	
	/**
	 * 一次性模块，即只有一次调用，可以把所有用到的变量保存到根作用域中
	 * */
	
	;!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
	        var $ = __webpack_require__(1);
	        var Handlebars = __webpack_require__(99);
	        var io = __webpack_require__(95);
	        var PollingStore = __webpack_require__(158);
	
	        __webpack_require__(159);
	
	        var hideClass = 'f-dn';
	        var disableClass = 'disabled';
	
	        var authData = null;
	
	        var $authWrap = null;
	        var $loginForm = null;
	
	        var $authBody = null;
	        var $authFooter = null;
	        var $btnAuthConfirm = null;
	        var $btnSubmit = null;
	
	        var toggleAuthWrap = function(showAuth) {
	            showAuth = typeof showAuth === 'boolean' ? showAuth : false;
	
	            if (showAuth) {
	                $loginForm.addClass(hideClass);
	                $authWrap.removeClass(hideClass);
	            } else {
	                $authWrap.addClass(hideClass);
	                $loginForm.removeClass(hideClass);
	            }
	        };
	
	        var focusInput = function($input, enterCb) {
	            if (!$input || !$input.length) return false;
	
	            enterCb = $.isFunction(enterCb) ? enterCb : $.noop;
	
	            $input
	                    .off('focus')
	                    .on('focus', function() {
	                        $(this).off('keyup.enter').on('keyup.enter', function(e) {
	                            if (e.keyCode === 13) {
	                                enterCb(e);
	                            }
	                        });
	                    })
	                    .off('blur')
	                    .on('blur', function() {
	                        $(this).off('keyup.enter');
	                    });
	
	            setTimeout(function() {
	                $input.trigger('focus');
	            }, 200);
	        };
	
	        var checkCode = function(errorMsg) {
	            var $code = $authBody.find('.j-code');
	            var $wrapper = $authBody.find('.j-wrap');
	            var $error = $wrapper.find('.j-error');
	            var codeValue = $.trim($code.val()).toUpperCase();
	            if (!codeValue.length) {
	                // 验证码不能为空
	                if ($error.length > 0) {
	                    $error.remove();
	                }
	
	                $wrapper.append(Handlebars.compile($('#errorMsgTpl').html())({
	                    errorMsg: errorMsg
	                }));
	
	                $code.focus();
	                return '';
	            } else {
	                return codeValue;
	            }
	        };
	
	        var triggerSubmit = function() {
	            if (!$btnAuthConfirm || !$btnAuthConfirm.length) return false;
	            $btnAuthConfirm.trigger('click');
	        };
	
	        var SmsVerifyFactory = function(options) {
	            this.authData = options.authData;
	            this._render();
	            this._initEvents();
	        };
	
	        SmsVerifyFactory.prototype = {
	            constructor: SmsVerifyFactory,
	            submit: function() {
	                var codeValue = checkCode(this.authData.emptySMSCodeMsg);
	
	                if (codeValue.length > 0) {
	                    $loginForm.find('#verifyCellCode').val(codeValue);
	                    $btnSubmit.trigger('click');
	                }
	            },
	            cancel: function() {
	                this._offEvents();
	            },
	            _render: function() {
	                $authBody.html(Handlebars.compile($('#smsVerifyTpl').html())(this.authData));
	                focusInput($authBody.find('.j-code'), triggerSubmit);
	            },
	            _initEvents: function() {
	                $authBody.off('click', '.j-send').on('click', '.j-send', $.proxy(this._handleSendCode, this));
	            },
	            _offEvents: function() {
	                $authBody.off('click', '.j-send');
	            },
	            _handleSendCode: function() {
	                $loginForm.find('#resendCellCode').prop('disabled', false);
	                $btnSubmit.trigger('click');
	            }
	        };
	
	        var KeyVerifyFactory = function(options) {
	            this.authData = options.authData;
	            this._render();
	        };
	
	        KeyVerifyFactory.prototype = {
	            constructor: KeyVerifyFactory,
	            submit: function() {
	                var codeValue = checkCode(this.authData.emptyDynamicPasswordMsg);
	
	                if (codeValue.length > 0) {
	                    $loginForm.find('.j-form-dynamicPwd').val(codeValue);
	                    $btnSubmit.trigger('click');
	                }
	            },
	            cancel: function() {
	                // do nothing
	            },
	            _render: function() {
	                $authBody.html(Handlebars.compile($('#dynamic1VerifyTpl').html())(this.authData));
	                focusInput($authBody.find('.j-code'), triggerSubmit);
	            }
	        };
	
	        var OtpVerifyFactory = function(options) {
	            this.authData = options.authData;
	            this.authType = this.authEnums.PUSH;
	
	            this.$verifyWrap = null;
	            this.observer = null;
	
	            this._render();
	        };
	
	        OtpVerifyFactory.prototype = {
	            constructor: OtpVerifyFactory,
	            authEnums: {
	                PUSH: 1,
	                CODE: 2
	            },
	            submit: function() {
	                var codeValue = '';
	
	                if (this.authType === this.authEnums.PUSH) {
	                    this._doSubmit(codeValue);
	                } else {
	                    codeValue = checkCode(this.authData.emptyAuthCodeMsg);
	
	                    if (codeValue.length > 0) {
	                        this._doSubmit(codeValue);
	                    }
	                }
	            },
	            cancel: function() {
	                this._unSubscribe();
	            },
	            _unSubscribe: function() {
	                this.observer != null && this.observer.unSubscribe();
	            },
	            _doSubmit: function(verifyCode) {
	                this.observer != null && this.observer.unSubscribe();
	
	                $loginForm.find('.j-form-dynamicPwd').val(verifyCode);
	                $btnSubmit.trigger('click');
	            },
	            _render: function() {
	                $authBody.html(Handlebars.compile($('#dynamic2VerifyWrapTpl').html())());
	                this.$verifyWrap = $authBody.find('.j-dynamic2-verify');
	
	                if (this.authType === this.authEnums.CODE) {
	                    this._renderCode();
	                } else {
	                    this._renderPush();
	                }
	
	                this._prepareValidate();
	            },
	            _renderPush: function() {
	                var self = this;
	                this.authType = this.authEnums.PUSH;
	
	                $btnAuthConfirm.addClass(disableClass).addClass(hideClass);
	
	                this.$verifyWrap.html(Handlebars.compile($('#dynamic2PushVerifyTpl').html())(this.authData));
	
	                this.$verifyWrap.off('click', '.j-toggle').on('click', '.j-toggle', function() {
	                    self._renderCode();
	                });
	            },
	            _renderCode: function() {
	                var self = this;
	                this.authType = this.authEnums.code;
	
	                $btnAuthConfirm.removeClass(disableClass).removeClass(hideClass);
	
	                this.$verifyWrap.html(Handlebars.compile($('#dynamic2CodeVerifyTpl').html())(this.authData));
	                focusInput($authBody.find('.j-code'), triggerSubmit);
	
	                this.$verifyWrap.off('click', '.j-toggle').on('click', '.j-toggle', function() {
	                    self._renderPush();
	                });
	            },
	            _prepareValidate: function() {
	                var self = this;
	                var authData = this.authData;
	
	                $.ajax({
	                    type: 'POST',
	                    url: '/@context.name@/s/json?func=user:triggerSecondAuth',
	                    data: '{"trans": "login", "tempSid": "' + authData.tempSession + '"}',
	                    headers: {
	                        Accept: 'text/x-json'
	                    },
	                    contentType: 'text/x-json'
	                }).done(function(data) {
	                    if (data && data.code && data.code !== 'S_OK') {
	                        // todo: 提示错误信息
	                    } else {
	                        self._subscribeValidate();
	                    }
	                }).fail(function() {
	                    // todo: 提示错误信息
	                });
	            },
	            _subscribeValidate: function() {
	                var self = this;
	                var topic = WsStore.topics.OTP_AUTH;
	                var authData = this.authData;
	
	                if (('WebSocket' in window)) {
	                    topic = topic.replace('$uid$', authData.uid);
	                    topic = topic.replace('$tempsid$', authData.tempSession);
	
	                    WsStore.subscribe(topic, function(msgData) {
	                        var trans = msgData.payload.trans;
	
	                        if (trans !== 'login') {
	                            alert('invalid trans');
	                            return false;
	                        }
	
	                        WsStore.unSubscribe();
	
	                        $.ajax({
	                            type: 'POST',
	                            url: '/@context.name@/s/json?func=user:querySecondAuthValidateStage',
	                            data: '{"trans": "login", "tempSid": "' + authData.tempSession + '"}',
	                            headers: {
	                                Accept: 'text/x-json'
	                            },
	                            contentType: 'text/x-json'
	                        }).done(function(data) {
	                            self._unSubscribe();
	
	                            var code = data && data.code;
	                            if (code === 'S_OK') {
	                                if (data['var'] && data['var']['stage'] === 'VALIDATED') {
	                                    $btnAuthConfirm.removeClass(disableClass).removeClass(hideClass);
	                                    $btnAuthConfirm.trigger('click');
	                                }
	                                return;
	                            }
	
	                            // 若otp 推送的session 过期，
	                            // 鉴于现在交互设计中，不需要重新发送推送请求，所以，
	                            // 在不刷新的情况下，则强制使用手动输入验证码授权登录
	                            if (code === 'FA_INVALID_TEMP_SESSION') {
	                                authData.forceCode = true;
	                                self._renderCode();
	                            }
	                            // todo: 提示其他类型错误信息
	                        }).fail(function() {
	                            self._unSubscribe();
	                            // todo: 提示错误信息
	                        });
	                    }, {
	                        authMeta: {
	                            clientId : 'webmail:' + authData.tempSession,
	                            sid      : authData.tempSession,
	                            TmpSes   : 1
	                        },
	                        io: io,
	                        host: self.authData.host
	                    });
	                    this.observer = WsStore;
	                } else {
	                    this.observer = new PollingStore({
	                        topic: '/@context.name@/s/json?func=user:querySecondAuthValidateStage',
	                        data: '{"trans": "login", "tempSid": "' + authData.tempSession + '"}',
	                        successCallback: function(result) {
	                            if (result.stage && result.stage === 'VALIDATED') {
	                                self._unSubscribe();
	                                $btnAuthConfirm.removeClass(disableClass).removeClass(hideClass);
	                                $btnAuthConfirm.trigger('click');
	                            }
	                        },
	                        errorCallback: function(data) {
	                            if (data.code === 'FA_INVALID_SESSION' || data.code === 'FA_INVALID_TEMP_SESSION') {
	                                self._unSubscribe();
	                            }
	                        }
	                    }).subscribe();
	                }
	            }
	        };
	
	
	        var initVerify = function(options) {
	            var verifyIns;
	            var backObserver;
	
	            if ($.isEmptyObject(options)) {
	                return false;
	            }
	
	            backObserver = options.backObserver || $.noop;
	
	            authData = options.authData;
	
	            $authWrap = options.$authWrap;
	            $loginForm = options.$loginForm;
	
	            $authBody = $authWrap.find('.j-auth-body');
	            $authFooter = $authWrap.find('.j-auth-footer');
	            $btnAuthConfirm = $authFooter.find('.j-confirm');
	
	            $btnSubmit = $loginForm.find('.j-submit');
	
	            if (authData.dynamic1) {
	                verifyIns = new KeyVerifyFactory({
	                    authData: authData
	                });
	            } else if (authData.dynamic2) {
	                verifyIns = new OtpVerifyFactory({
	                    authData: authData
	                });
	            } else if (authData.sms) {
	                verifyIns = new SmsVerifyFactory({
	                    authData: authData
	                });
	            }
	
	            toggleAuthWrap(true);
	
	            $authFooter.off('click', '.j-confirm').on('click', '.j-confirm', function() {
	                var vcCode;
	
	                if (options.authData.needVerifyCode) {
	                    vcCode = $.trim($authWrap.find('.j-vc-verify-code').val());
	
	                    if (!vcCode.length) {
	                        // todo: 使用轻量点的dialog 组件
	                        alert(options.authData.emptyVerifyCodeMsg);
	                        return;
	                    }
	
	                    $loginForm.find('.j-vc-verify-code').val(vcCode.toUpperCase());
	                }
	
	                var $authorizeDevice = $authFooter.find('.j-authorize-device');
	                var isNeedToAuthorizeDevice;
	                if ($authorizeDevice.length) {
	                    isNeedToAuthorizeDevice = $authorizeDevice.prop('checked');
	                    if (isNeedToAuthorizeDevice) $loginForm.find('.j-authorizeDevice').val(true);
	                }
	                verifyIns.submit();
	            });
	
	            $authFooter.off('click', '.j-back').on('click', '.j-back', function(e) {
	                if (backObserver() === false) return;
	
	                verifyIns.cancel();
	                toggleAuthWrap(false);
	            });
	
	            $authFooter.off('click', '.j-back-to-referrer').on('click', '.j-back-to-referrer', function() {
	                verifyIns.cancel();
	
	                var $referrer = $loginForm.find('.j-startReferrer');
	                if ($referrer.length && $referrer.val().length) {
	                    location.replace($referrer.val());
	                } else {
	                    if (backObserver() === false) return;
	                    toggleAuthWrap(false);
	                }
	            });
	        };
	
	        return {
	            initVerify: initVerify
	        };
	    }.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ },

/***/ 158:
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*
	*   ��װ��ά��ɨ����¼��ѯ�����߼�
	*   ���ó�����
	*       1.��ά��ɨ����½
	*       2.������֤��½����
	*       3.�����һ��Ż�����
	*
	*   dependence:
	*       1.jquery
	* */
	
	(function(global, factory) {
	    if (true) {
	        // Register as an anonymous AMD module:
	        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(1)], __WEBPACK_AMD_DEFINE_RESULT__ = function($) {
	            return factory(global, $);
	        }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	    } else if (typeof module === "object" && typeof module.exports === "object") {
	        // Node/CommonJS:
	        module.exports = factory(global, require('jquery'));
	    } else {
	        // Browser globals:
	        factory(global, window.jQuery);
	    }
	})(typeof window !== 'undefined' ? window : this, function(window, $) {
	    function pollStore(options) {
	        var xhr = null; // �첽��������
	        var isOn = false; //
	        var interval = null; //
	
	        options = $.extend({
	            topic: '',                   // ��ѯ·��
	            interval: 5000,              // ��ѯ����5��
	            timeout: 5000,                // ������ʱʱ��5��
	            successCallback: $.noop(),  // �����ɹ��ص�����
	            errorCallback: $.noop()     // ���������ص�����
	        }, options || {});
	
	        function _isFunction(callback) {
	            return typeof callback == 'function';
	        }
	
	        this.subscribe = function() {
	            var self = this;
	            if (isOn) return false;
	            if (!options.topic) return false;
	
	            interval = setInterval(function() {
	                xhr = $.ajax({
	                    url: options.topic,
	                    data: options.data || '',
	                    headers: {Accept: 'text/x-json'},
	                    contentType: 'text/x-json',
	                    type: 'post',
	                    timeout: options.timeout
	                }).done(function(data, textStatus, jqXHR) {
	                    data = data || {};
	                    if (data.code === 'S_OK') { // ������ΪS_OK
	                        _isFunction(options.successCallback) &&
	                            options.successCallback(data['var'] || {});
	                    } else {
	                        if (data.code == 'FA_INVALID_SESSION') { // sessionʧЧ�������£��Զ�ȡ������
	                            self.unSubscribe();
	                        }
	                        _isFunction(options.errorCallback) &&
	                            options.errorCallback(data, textStatus, jqXHR);
	                    }
	                }).fail(function(data, textStatus, jqXHR) {
	                    _isFunction(options.errorCallback) &&
	                        options.errorCallback(data, textStatus, jqXHR);
	                });
	            }, options.interval);
	
	            isOn = true;
	
	            return this;
	        };
	
	        // ��ֹ��ѯ
	        this.unSubscribe = function() {
	            interval && clearInterval(interval);
	            if (xhr) {
	                xhr.abort();
	                xhr = null;
	            }
	        };
	    }
	    window.PollStore = pollStore;
	    return pollStore;
	});


/***/ },

/***/ 159:
/***/ function(module, exports) {

	/*
	 * Copyright (c) 2016 Mailtech.cn, Ltd. All Rights Reserved.
	 */
	
	/**
	 * dependency:
	 * �����ּǣ�
	 * ������ͳһ������Siosvr��websocket ���ͣ�֮���Ķ��ġ�ȡ�����ġ���Ϣ����
	 *
	 * 1. ϵͳ�ӿ�
	 *      destroy(): ����
	 *      unSubscribe(): ����
	 *      subscribe(): ע����Ϣ���ͻص�������websocket ����
	 *      topics: ��ע������Ϣ����
	 * */
	
	;(function(global) {
	
	    if (global.console == null) {
	        global.console = {
	            log: function() {}
	        };
	    }
	    if (console.debug == null) {
	        // console.debug is non standard, but we can use this keyword to suppress some messages later
	        console.debug = console.log;
	    }
	
	    var topicEnums = {
	        SCANQRCODE  : '/$org_id$/onstat/mail/$tempsid$/op_app_scanqrcode',          // App��ά��ɨ����¼ | ɨ����������
	        OTP_AUTH    : '/second_auth/$uid$/$tempsid$/op_app_authed_device_cert'       // Otp Auth ��¼
	    };
	
	    var op = Object.prototype;
	    var oToString = op.toString;
	
	    var bind = function(fn, ctx) {
	        return function(a) {
	            var l = arguments.length;
	            return l
	                    ? l > 1
	                        ? fn.apply(ctx, arguments)
	                        : fn.call(ctx, a)
	                    : fn.call(ctx);
	        };
	    };
	
	    var isFunction = function(it) {
	        return oToString.call(it) === '[object Function]';
	    };
	
	    var noop = function() {};
	
	    var rtrim = /^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g;
	    var trim = function( text ) {
	        return text == null ?
	                "" :
	                ( text + "" ).replace( rtrim, "" );
	    };
	
	    var rvalidtokens = /(,)|(\[|{)|(}|])|"(?:[^"\\\r\n]|\\["\\\/bfnrt]|\\u[\da-fA-F]{4})*"\s*:?|true|false|null|-?(?!0\d)\d+(?:\.\d+|)(?:[eE][+-]?\d+|)/g;
	    var parseJSON = function( data ) {
	        // Attempt to parse using the native JSON parser first
	        if ( window.JSON && window.JSON.parse ) {
	            // Support: Android 2.3
	            // Workaround failure to string-cast null input
	            return window.JSON.parse( data + "" );
	        }
	
	        var requireNonComma,
	            depth = null,
	            str = trim( data + "" );
	
	        // Guard against invalid (and possibly dangerous) input by ensuring that nothing remains
	        // after removing valid tokens
	        return str && !trim( str.replace( rvalidtokens, function( token, comma, open, close ) {
	
	            // Force termination if we see a misplaced comma
	            if ( requireNonComma && comma ) {
	                depth = 0;
	            }
	
	            // Perform no more replacements after returning to outermost depth
	            if ( depth === 0 ) {
	                return token;
	            }
	
	            // Commas must not follow "[", "{", or ","
	            requireNonComma = open || comma;
	
	            // Determine new depth
	            // array/object open ("[" or "{"): depth += true - false (increment)
	            // array/object close ("]" or "}"): depth += false - true (decrement)
	            // other cases ("," or primitive): depth += true - true (numeric cast)
	            depth += !close - !open;
	
	            // Remove this token
	            return "";
	        }) ) ?
	                ( Function( "return " + str ) )() :
	                console.debug( "Invalid JSON: " + data );
	    };
	
	    var isSessionExpired = function(expireTime) {
	        return expireTime !== -1 && new Date().getTime() > expireTime;
	    };
	
	    var Store = {
	        topic: null,        // ���룬�����滻����
	        observer: null,     // ����
	        authMeta: {},       // ����
	
	        host: null,         // ����
	        io: null,           // ���룬socket.io ��
	
	        maxConnTimes: 3,
	        connTimes: 0,
	        expireTime: -1, // siosvr����ʱsession����ʱ�䣬��ȷ������, -1 ��ʾ�޵���ʱ��
	
	        // socket.io ����ʵ��
	        socket: null,
	
	        // ����websocket �����Ƿ������ϲ���֤�ɹ�
	        isReady: false,
	
	        _init: function(config) {
	            if (config.io == null) {
	                console.log('invalid io factory for websocket conn!');
	                return false;
	            }
	
	            if (config.host == null) {
	                console.log('invalid host for websocket conn!');
	                return false;
	            }
	
	            if (config.authMeta == null) {
	                console.log('invalid authMeta for websocket conn!');
	                return false;
	            }
	
	            this.host = config.host;
	            this.io = config.io;
	            this.authMeta = config.authMeta;
	            this.expireTime = config.expireTime || this.expireTime;
	
	            this._on();
	        },
	
	        _on: function() {
	            this.socket = this.io.connect(this.host, {forceNew: true});
	            this.socket
	                    .on('connect', bind(this._onConnect, this))
	                    .on('auth_error', bind(this._onAuthError,this))
	                    .on('ready', bind(this._onReady, this))
	                    .on('message', bind(this._onMessage, this))
	                    .on('connect_error', bind(this._onConnectError, this))
	                    .on('connect_timeout', bind(this._onConnectTimeout, this))
	                    .on('disconnect', bind(this._onDisconnect, this))
	                    .on('reconnecting', bind(this._onReconnecting, this));
	        },
	
	        destroy: function() {
	            this.unSubscribe();
	        },
	
	        subscribe: function(topic, observer, options) {
	            ++Store.uid;
	
	            if (options == null) {
	                return false;
	            }
	
	            this.topic = topic;
	            this.observer = isFunction(observer) ? observer : noop;
	
	            this._init(options);
	        },
	
	        unSubscribe: function() {
	            this._doUnSubscribe();
	            this._destroySocket();
	
	            delete this.tempSid;
	        },
	
	        _doUnSubscribe: function() {
	            this.socket && this.socket.emit('unsubscribe',{topic: this.topic});
	            delete this.topic;
	            delete this.observer;
	            this.authMeta = {};
	        },
	
	        _destroySocket: function() {
	            this.socket && this.socket.emit('disconnect').close();
	
	            this.socket = null;
	            this.connTimes = 0;
	            this.isReady = false;
	        },
	
	        _onConnect: function() {
	            if (this.connTimes > this.maxConnTimes || isSessionExpired(this.expireTime)) {
	                this._destroySocket();
	                return false;
	            }
	
	            //this.socket.emit('auth', {
	            //    clientId : 'webmail:' + this.tempSid,
	            //    sid      : this.tempSid,
	            //    TmpSes   : 1
	            //});
	
	            this.socket.emit('auth', this.authMeta);
	
	            ++this.connTimes;
	        },
	
	        _onAuthError: function() {
	            console.log('websocket auth error');
	        },
	
	        _onReady: function() {
	            console.log('websocket ready');
	            this.isReady = true;
	
	            this.socket.emit('subscribe', {topic: this.topic});
	        },
	
	        _onMessage: function(msg) {
	            console.log(msg);
	
	            var topic = msg.topic;
	            var payload = parseJSON(msg.payload);
	
	            if (topic == this.topic) {
	                this.observer(payload);
	            }
	        },
	
	        _onConnectError: function(error) {
	            console.log('websocket connectError: ' + error);
	        },
	
	        _onConnectTimeout: function() {
	            console.log('websocket connect timeout');
	        },
	
	        _onDisconnect: function(error) {
	            console.log('websocket disconnect: ' + error);
	        },
	
	        _onReconnecting: function() {
	            this._onConnect();
	        }
	    };
	
	    Store.topics = topicEnums;
	
	    window.WsStore = Store;
	
	})(typeof window !== 'undefined' ? window : this);

/***/ },

/***/ 457:
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;/*
	 A JavaScript implementation of the SHA family of hashes, as
	 defined in FIPS PUB 180-4 and FIPS PUB 202, as well as the corresponding
	 HMAC implementation as defined in FIPS PUB 198a
	
	 Copyright Brian Turek 2008-2016
	 Distributed under the BSD License
	 See http://caligatio.github.com/jsSHA/ for more information
	
	 Several functions taken from Paul Johnston
	*/
	'use strict';(function(G){function t(e,a,d){var g=0,c=[],b=0,f,k,l,h,m,w,n,y,p=!1,q=[],t=[],v,u=!1;d=d||{};f=d.encoding||"UTF8";v=d.numRounds||1;l=z(a,f);if(v!==parseInt(v,10)||1>v)throw Error("numRounds must a integer >= 1");if("SHA-1"===e)m=512,w=A,n=H,h=160,y=function(a){return a.slice()};else throw Error("Chosen SHA variant is not supported");k=x(e);this.setHMACKey=function(a,b,c){var d;if(!0===p)throw Error("HMAC key already set");if(!0===u)throw Error("Cannot set HMAC key after calling update");
	f=(c||{}).encoding||"UTF8";b=z(b,f)(a);a=b.binLen;b=b.value;d=m>>>3;c=d/4-1;if(d<a/8){for(b=n(b,a,0,x(e),h);b.length<=c;)b.push(0);b[c]&=4294967040}else if(d>a/8){for(;b.length<=c;)b.push(0);b[c]&=4294967040}for(a=0;a<=c;a+=1)q[a]=b[a]^909522486,t[a]=b[a]^1549556828;k=w(q,k);g=m;p=!0};this.update=function(a){var d,e,f,h=0,n=m>>>5;d=l(a,c,b);a=d.binLen;e=d.value;d=a>>>5;for(f=0;f<d;f+=n)h+m<=a&&(k=w(e.slice(f,f+n),k),h+=m);g+=h;c=e.slice(h>>>5);b=a%m;u=!0};this.getHash=function(a,d){var f,l,m,r;if(!0===
	p)throw Error("Cannot call getHash after setting HMAC key");m=B(d);switch(a){case "HEX":f=function(a){return C(a,h,m)};break;case "B64":f=function(a){return D(a,h,m)};break;case "BYTES":f=function(a){return E(a,h)};break;case "ARRAYBUFFER":try{l=new ArrayBuffer(0)}catch(I){throw Error("ARRAYBUFFER not supported by this environment");}f=function(a){return F(a,h)};break;default:throw Error("format must be HEX, B64, BYTES, or ARRAYBUFFER");}r=n(c.slice(),b,g,y(k),h);for(l=1;l<v;l+=1)r=n(r,h,0,x(e),h);
	return f(r)};this.getHMAC=function(a,d){var f,l,q,r;if(!1===p)throw Error("Cannot call getHMAC without first setting HMAC key");q=B(d);switch(a){case "HEX":f=function(a){return C(a,h,q)};break;case "B64":f=function(a){return D(a,h,q)};break;case "BYTES":f=function(a){return E(a,h)};break;case "ARRAYBUFFER":try{f=new ArrayBuffer(0)}catch(I){throw Error("ARRAYBUFFER not supported by this environment");}f=function(a){return F(a,h)};break;default:throw Error("outputFormat must be HEX, B64, BYTES, or ARRAYBUFFER");
	}l=n(c.slice(),b,g,y(k),h);r=w(t,x(e));r=n(l,h,m,r,h);return f(r)}}function J(e,a,d){var g=e.length,c,b,f,k,l;a=a||[0];d=d||0;l=d>>>3;if(0!==g%2)throw Error("String of HEX type must be in byte increments");for(c=0;c<g;c+=2){b=parseInt(e.substr(c,2),16);if(isNaN(b))throw Error("String of HEX type contains invalid characters");k=(c>>>1)+l;for(f=k>>>2;a.length<=f;)a.push(0);a[f]|=b<<8*(3-k%4)}return{value:a,binLen:4*g+d}}function K(e,a,d){var g=[],c,b,f,k,g=a||[0];d=d||0;b=d>>>3;for(c=0;c<e.length;c+=
	1)a=e.charCodeAt(c),k=c+b,f=k>>>2,g.length<=f&&g.push(0),g[f]|=a<<8*(3-k%4);return{value:g,binLen:8*e.length+d}}function L(e,a,d){var g=[],c=0,b,f,k,l,h,m,g=a||[0];d=d||0;a=d>>>3;if(-1===e.search(/^[a-zA-Z0-9=+\/]+$/))throw Error("Invalid character in base-64 string");f=e.indexOf("=");e=e.replace(/\=/g,"");if(-1!==f&&f<e.length)throw Error("Invalid '=' found in base-64 string");for(f=0;f<e.length;f+=4){h=e.substr(f,4);for(k=l=0;k<h.length;k+=1)b="ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/".indexOf(h[k]),
	l|=b<<18-6*k;for(k=0;k<h.length-1;k+=1){m=c+a;for(b=m>>>2;g.length<=b;)g.push(0);g[b]|=(l>>>16-8*k&255)<<8*(3-m%4);c+=1}}return{value:g,binLen:8*c+d}}function M(e,a,d){var g=[],c,b,f,g=a||[0];d=d||0;c=d>>>3;for(a=0;a<e.byteLength;a+=1)f=a+c,b=f>>>2,g.length<=b&&g.push(0),g[b]|=e[a]<<8*(3-f%4);return{value:g,binLen:8*e.byteLength+d}}function C(e,a,d){var g="";a/=8;var c,b;for(c=0;c<a;c+=1)b=e[c>>>2]>>>8*(3-c%4),g+="0123456789abcdef".charAt(b>>>4&15)+"0123456789abcdef".charAt(b&15);return d.outputUpper?
	g.toUpperCase():g}function D(e,a,d){var g="",c=a/8,b,f,k;for(b=0;b<c;b+=3)for(f=b+1<c?e[b+1>>>2]:0,k=b+2<c?e[b+2>>>2]:0,k=(e[b>>>2]>>>8*(3-b%4)&255)<<16|(f>>>8*(3-(b+1)%4)&255)<<8|k>>>8*(3-(b+2)%4)&255,f=0;4>f;f+=1)8*b+6*f<=a?g+="ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/".charAt(k>>>6*(3-f)&63):g+=d.b64Pad;return g}function E(e,a){var d="",g=a/8,c,b;for(c=0;c<g;c+=1)b=e[c>>>2]>>>8*(3-c%4)&255,d+=String.fromCharCode(b);return d}function F(e,a){var d=a/8,g,c=new ArrayBuffer(d);
	for(g=0;g<d;g+=1)c[g]=e[g>>>2]>>>8*(3-g%4)&255;return c}function B(e){var a={outputUpper:!1,b64Pad:"=",shakeLen:-1};e=e||{};a.outputUpper=e.outputUpper||!1;!0===e.hasOwnProperty("b64Pad")&&(a.b64Pad=e.b64Pad);if("boolean"!==typeof a.outputUpper)throw Error("Invalid outputUpper formatting option");if("string"!==typeof a.b64Pad)throw Error("Invalid b64Pad formatting option");return a}function z(e,a){var d;switch(a){case "UTF8":case "UTF16BE":case "UTF16LE":break;default:throw Error("encoding must be UTF8, UTF16BE, or UTF16LE");
	}switch(e){case "HEX":d=J;break;case "TEXT":d=function(d,c,b){var f=[],e=[],l=0,h,m,q,n,p,f=c||[0];c=b||0;q=c>>>3;if("UTF8"===a)for(h=0;h<d.length;h+=1)for(b=d.charCodeAt(h),e=[],128>b?e.push(b):2048>b?(e.push(192|b>>>6),e.push(128|b&63)):55296>b||57344<=b?e.push(224|b>>>12,128|b>>>6&63,128|b&63):(h+=1,b=65536+((b&1023)<<10|d.charCodeAt(h)&1023),e.push(240|b>>>18,128|b>>>12&63,128|b>>>6&63,128|b&63)),m=0;m<e.length;m+=1){p=l+q;for(n=p>>>2;f.length<=n;)f.push(0);f[n]|=e[m]<<8*(3-p%4);l+=1}else if("UTF16BE"===
	a||"UTF16LE"===a)for(h=0;h<d.length;h+=1){b=d.charCodeAt(h);"UTF16LE"===a&&(m=b&255,b=m<<8|b>>>8);p=l+q;for(n=p>>>2;f.length<=n;)f.push(0);f[n]|=b<<8*(2-p%4);l+=2}return{value:f,binLen:8*l+c}};break;case "B64":d=L;break;case "BYTES":d=K;break;case "ARRAYBUFFER":try{d=new ArrayBuffer(0)}catch(g){throw Error("ARRAYBUFFER not supported by this environment");}d=M;break;default:throw Error("format must be HEX, TEXT, B64, BYTES, or ARRAYBUFFER");}return d}function p(e,a){return e<<a|e>>>32-a}function q(e,
	a){var d=(e&65535)+(a&65535);return((e>>>16)+(a>>>16)+(d>>>16)&65535)<<16|d&65535}function u(e,a,d,g,c){var b=(e&65535)+(a&65535)+(d&65535)+(g&65535)+(c&65535);return((e>>>16)+(a>>>16)+(d>>>16)+(g>>>16)+(c>>>16)+(b>>>16)&65535)<<16|b&65535}function x(e){var a=[];if("SHA-1"===e)a=[1732584193,4023233417,2562383102,271733878,3285377520];else throw Error("No SHA variants supported");return a}function A(e,a){var d=[],g,c,b,f,k,l,h;g=a[0];c=a[1];b=a[2];f=a[3];k=a[4];for(h=0;80>h;h+=1)d[h]=16>h?e[h]:p(d[h-
	3]^d[h-8]^d[h-14]^d[h-16],1),l=20>h?u(p(g,5),c&b^~c&f,k,1518500249,d[h]):40>h?u(p(g,5),c^b^f,k,1859775393,d[h]):60>h?u(p(g,5),c&b^c&f^b&f,k,2400959708,d[h]):u(p(g,5),c^b^f,k,3395469782,d[h]),k=f,f=b,b=p(c,30),c=g,g=l;a[0]=q(g,a[0]);a[1]=q(c,a[1]);a[2]=q(b,a[2]);a[3]=q(f,a[3]);a[4]=q(k,a[4]);return a}function H(e,a,d,g){var c;for(c=(a+65>>>9<<4)+15;e.length<=c;)e.push(0);e[a>>>5]|=128<<24-a%32;a+=d;e[c]=a&4294967295;e[c-1]=a/4294967296|0;a=e.length;for(c=0;c<a;c+=16)g=A(e.slice(c,c+16),g);return g}
	 true?!(__WEBPACK_AMD_DEFINE_RESULT__ = function(){return t}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)):"undefined"!==typeof exports?("undefined"!==typeof module&&module.exports&&(module.exports=t),exports=t):G.jsSHA=t})(this);


/***/ },

/***/ 486:
/***/ function(module, exports, __webpack_require__) {

	module.exports = function() {
		return new Worker(__webpack_require__.p + "0065b3b65b579c817d46.worker.js");
	};

/***/ }

});


/** WEBPACK FOOTER **
 ** common-login.7e1a9.js
 **/